import { useContext, useEffect, useReducer, useRef } from 'react';

import { wizardContext } from '../../contexts/wizard-context';
import type { ContextState } from '../../types';
import { ECustomerTypeSelection, EWizardCustomerType } from '../../types';
import { useMiddleware } from '../../utils';
import { buildSetters } from './buildSetters';
import { useBackStep, useCustomerValidation } from './middleware';
import { reducer } from './reducer';

export function useReducerState({
  currentStep = 1,
  isBackEnabled = false,
  ...rest
}: Partial<ContextState>) {
  const [state, dispatch] = useMiddleware(
    useBackStep,
    useCustomerValidation,
  )(
    useReducer(reducer, {
      currentStep,
      isBackEnabled,
      termsAndConditionsAccepted: false,
      ...rest,
    }),
  );
  const { customerType } = useContext(wizardContext);
  const { current: actions } = useRef(buildSetters(dispatch));

  useEffect(() => {
    if (customerType === EWizardCustomerType.OnlyForOtherCustomers) {
      actions.setCustomerType(ECustomerTypeSelection.ExistingCustomer);
    } else {
      actions.setCustomerType(ECustomerTypeSelection.Myself);
    }
  }, [customerType, actions]);

  return { ...state, ...actions } as const;
}
